import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { usePortal } from "../../../context/PortalContext";
import { getSubdomainForForms } from "../../../utils/portalHost";
import { setStoredSubdomain } from "../../../utils/clinicStorage";
import authAPI from "../../../services/authApi";
import AuthShell from "../Auth/AuthShell";
import AuthField from "../Auth/AuthField";
import Button from "../../ui/Button";
import a from "../Auth/auth.module.css";

export default function PatientResetPassword() {
  const navigate = useNavigate();
  const { subdomain: hostSubdomain, clinic } = usePortal();
  const [params] = useSearchParams();
  const subdomainFromQuery = (params.get("subdomain") || "").trim().toLowerCase();
  const subdomain =
    hostSubdomain || subdomainFromQuery || getSubdomainForForms() || "";
  const clubName = clinic?.name || null;
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [step, setStep] = useState(1);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const token = params.get("token") || "";
  const email = params.get("email") || "";

  useEffect(() => {
    if (subdomainFromQuery && !hostSubdomain) {
      setStoredSubdomain(subdomainFromQuery);
    }
  }, [subdomainFromQuery, hostSubdomain]);

  const next = (e) => {
    e.preventDefault();
    if (password.length < 8) {
      setErr("Минимум 8 символов");
      return;
    }
    if (password !== confirm) {
      setErr("Пароли не совпадают");
      return;
    }
    setErr("");
    setStep(2);
  };

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await authAPI.resetPassword(
        token,
        email,
        password,
        subdomain,
      );
      if (r.result === 0) {
        navigate("/login", { replace: true });
      } else {
        setErr(r.error || "Ошибка");
        setStep(1);
      }
    } catch (e) {
      setErr(e.response?.data?.error || "Ошибка");
      setStep(1);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      modern
      backTo="/login"
      backLabel="К входу"
      showSwitcher={false}
      cardTitle="Новый пароль"
      hint="Придумайте надёжный пароль — минимум 8 символов."
      clubTag={clubName}
      stepCurrent={step}
      stepTotal={2}
      stepLabels={["Пароль", "Готово"]}
    >
      {err ? <div className={a.errorBox}>{err}</div> : null}

      {step === 1 ? (
        <form onSubmit={next}>
          <AuthField
            label="Пароль"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            minLength={8}
            required
          />
          <AuthField
            label="Повтор"
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            minLength={8}
            required
          />
          <div className={a.actions}>
            <Button type="submit" block size="lg" disabled={!token}>
              Сохранить
            </Button>
          </div>
        </form>
      ) : (
        <form onSubmit={submit}>
          <div className={a.actions}>
            <Button type="submit" block size="lg" disabled={loading}>
              {loading ? "Сохранение…" : "Подтвердить"}
            </Button>
            <Button
              type="button"
              variant="ghost"
              block
              onClick={() => setStep(1)}
              disabled={loading}
            >
              Назад
            </Button>
          </div>
        </form>
      )}
    </AuthShell>
  );
}
